const getInvoicesList = (state) => state.invoices.list;
const getChargebeeInvoicesList = (state) => state.invoices.chargebeeList;
const getChargebeeCreditNotesList = (state) => state.invoices.chargebeeCreditNotesList;
const getInvoicesCount = (state) => state.invoices.count;
const getCurrentPage = (state) => state.invoices.currentPage;
const getSource = (state) => state.invoices.source;

const invoicesSelectors = {
  getInvoicesList,
  getChargebeeInvoicesList,
  getChargebeeCreditNotesList,
  getInvoicesCount,
  getCurrentPage,
  getSource,
};

export default invoicesSelectors;
